import { SEARCH_URL } from '@/constants';
import { NotFoundError, UnauthorizedError, UnexpectedError, UnprocessableEntity } from '@/services';
import { FormRisk } from '@/types';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';
import { parseRiskModelToForm } from './parse-risk-model-to-form';

export const loadFormDataByUUID = async (searchUUID: string): Promise<FormRisk> => {
  const httpResponse = await httpClient.get(fromBff(`${SEARCH_URL}/${searchUUID}`));

  switch (httpResponse.status) {
    case HttpStatusCode.ok:
      return parseRiskModelToForm(httpResponse.body.data);

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.notFound:
      throw new NotFoundError();

    case HttpStatusCode.unprocessableEntity:
      throw new UnprocessableEntity();

    default:
      throw new UnexpectedError();
  }
};
